
















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Users from '@/store/modules/Users';
import CommentThreadDisplay from "@/components/comments/CommentThreadDisplay.vue";
import CommentThreadPanel from "@/components/comments/CommentThreadPanel.vue";
import SignUpDialog from '@/views/Auth/SignUpDialog.vue';

import Sticky from 'vue-sticky-directive';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Comments from '@/store/modules/Comments';
import MainCommentPanel from '@/components/common/MainCommentPanel.vue';

const usersModule = getModule(Users);
const workspaceOptionsModule = getModule(WorkspaceOptions)

@Component({
    name: 'ChoiceCardDialog',
    components: {
        SignUpDialog,
        ChoiceCard: () => import('./ChoiceCard.vue'),
        CommentThreadPanel,
        MainCommentPanel
    },
    directives: {
        Sticky,
    },
})
export default class ChoiceCardDialog extends Vue {
    @Prop({ type: Boolean, default: false })
    autofill!: boolean;

    @Prop({ type: Object })
    userDetails!: any;

    @Prop({ type: String })
    choiceName!: string;

    @Prop({ type: Boolean, default: null })
    open!: boolean | null;

    @Prop({ type: Boolean, default: false })
    appEmbed!: boolean;

    @Prop({type: Boolean, default: false})
    createChoice!: boolean

    @Watch('open', { immediate: true })
    onOpenChanged(newVal: boolean, oldVal: boolean) {
        this.dialog = this.open === true;
    }

    @Watch('dialog')
    onDialogChanged(newVal: boolean, oldVal: boolean) {
        this.$emit('clicked', newVal);
    }

    get commentRightWidth() {
        return workspaceOptionsModule.commentRightWidth;
    }

    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }

    get dialog() {
        return workspaceOptionsModule.dialog;
    }

    set dialog(dialog: boolean) {
        workspaceOptionsModule.setDialog(dialog);
    }

    get pinnedRight() {
        return workspaceOptionsModule.pinnedRight;
    }

    set pinnedRight(val) {
        workspaceOptionsModule.setPinnedRight(val);
    }

    get isLoggedIn(): boolean {
        return usersModule.currentAuthUser !== null;
    }

    private navDrawer = false;

    get openRight() {
        return workspaceOptionsModule.openRight;
    }

    set openRight(val) {
        workspaceOptionsModule.setOpenRight(val);
    }

}
